<template>
  <div class="lines-container">

    <!-- ========== ENCABEZADO ========== -->
    <section class="chat-header">
      <h1 class="chat-header__title">Chats</h1>
      <p class="chat-header__subtitle">
        Selecciona una línea para iniciar una conversación.
      </p>
    </section>

    <!-- ========== GRID DE TARJETAS O SPINNER DE CARGA ========== -->
    <div class="widgets-grid">
      <!-- Spinner mientras se cargan las líneas -->
      <div v-if="loading" class="loading-spinner">
        <span class="spinner"></span>
        <p>Cargando Líneas...</p>
      </div>

      <!-- Tarjetas de líneas disponibles -->
      <div
        v-else
        v-for="line in lines"
        :key="line.id"
        class="widget-card"
        :class="{ 'dimmed': hoveredWidget !== null && hoveredWidget !== line.id }"
        @mouseenter="hoveredWidget = line.id"
        @mouseleave="hoveredWidget = null"
      >
        <!-- Parte superior de la tarjeta (icono + info) -->
        <div class="widget-card__top">
          <ion-icon name="logo-whatsapp" class="widget-card__icon" />
          <div class="widget-card__info">
            <h3 class="widget-card__title">{{ line.line_name }}</h3>
            <p class="widget-card__subtitle">{{ line.phone_number }}</p>
          </div>
        </div>

        <!-- Botón para abrir el chat con la línea seleccionada -->
        <button class="widget-card__button" @click="goToChat(line.id)">
          <ion-icon name="chatbubble-ellipses-outline" />
          <span>Chat</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LinesSelector",
  data() {
    return {
      lines: [],               // Arreglo de líneas disponibles
      hoveredWidget: null,     // ID del widget actualmente enfocado por el mouse
      loading: true,           // Estado de carga de las líneas
    };
  },
  methods: {
    // ========== CARGA DE LÍNEAS DESDE EL SERVIDOR ==========
    async fetchLines() {
      this.loading = true;
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("Token no disponible");
          return;
        }

        const response = await axios.get("/lines", {
          headers: { Authorization: `Bearer ${token}` },
        });

        this.lines = response.data; 
      } catch (error) {
        console.error("Error al obtener las líneas:", error);
      } finally {
        this.loading = false; 
      }
    },

    // ========== NAVEGACIÓN AL CHAT DE UNA LÍNEA SELECCIONADA ==========
    goToChat(lineId) {
      this.$router.push({ name: "ChatPage", params: { lineId } });
    },
  },
  mounted() {
    // Ejecutar carga de líneas al montar el componente
    this.fetchLines(); 
  },
};
</script>

<style scoped>

/* ========== CONTENEDOR PRINCIPAL ========== */
.lines-container {
  padding: 20px;
  background: #f9fafb;
  height: 100vh;
  overflow-y: auto; 
}

/* ========== ENCABEZADO ========== */
.chat-header {
  margin: 0; 
  text-align: left;
  font-family: 'Manrope', sans-serif;
}

.chat-header__title {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.chat-header__subtitle {
  font-size: 1rem;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}

/* ========== GRID DE TARJETAS ========== */
.widgets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 30px;
  margin-bottom: 60px;
  font-family: 'Manrope', sans-serif;
}

/* ========== TARJETA DE LÍNEA ========== */
.widget-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  cursor: pointer;
}

.widget-card:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

/* ========== ENCABEZADO DE LA TARJETA ========== */
.widget-card__top {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

.widget-card__icon {
  font-size: 32px;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
  padding: 10px;
  border-radius: 50%;
}

.widget-card__info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.widget-card__title {
  font-size: 1.05rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.widget-card__subtitle {
  font-size: 0.88rem;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 2px;
}

/* ========== BOTÓN DE CHAT ========== */
.widget-card__button {
  margin-top: auto;
  padding: 10px 16px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.25s ease, transform 0.15s ease;
  font-family: 'Manrope', sans-serif;
}

.widget-card__button:hover { 
  background: linear-gradient(135deg, #2563eb, #1e40af); 
}

.widget-card__button:active {
  background: linear-gradient(135deg, #1e40af, #1e3a8a);
  transform: scale(0.97);
}

.widget-card__button ion-icon {
  font-size: 18px;
}

/* ========== EFECTO DE ATENUACIÓN EN TARJETAS NO HOVER ========== */
.dimmed {
  opacity: 0.88;
  filter: brightness(0.97) blur(0.4px);
  transition: all 0.3s ease;
}

/* ========== SPINNER DE CARGA ========== */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-column: 1 / -1;
  padding: 60px 20px;
  font-size: 16px;
  color: #64748b;
  gap: 16px;
  font-family: 'Manrope', sans-serif;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s ease-in-out infinite;
  position: relative;
}

.spinner::after {
  content: '';
  position: absolute;
  top: -8px;
  left: -8px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(59, 130, 246, 0.1);
  animation: pulse 1.6s infinite ease-in-out;
}

/* ========== ANIMACIONES ========== */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.2;
  }
}

/* ========== RESPONSIVE (MÓVILES) ========== */
@media (max-width: 768px) {
  .widgets-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .widget {
    padding: 20px 15px;
  }

  .widget-icon {
    font-size: 50px;
    padding: 12px;
  }

  .widget-title {
    font-size: 18px;
  }

  .widget-button {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>